// Shared empty-state display for all Activity page tabs.
// Centralizing the empty-state UI prevents each tab from duplicating the icon+message
// layout and ensures a consistent visual response across all four tab types.
import { BsInbox } from 'react-icons/bs';
import { Link } from 'wasp/client/router';

interface EmptyTabStateProps {
  message: string;
  actionLabel?: string;
  actionTo?: string;
}

export function EmptyTabState({
  message,
  actionLabel,
  actionTo,
}: EmptyTabStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 dark:bg-primary-950/30 mb-4">
        <BsInbox className="text-2xl text-primary" />
      </div>
      <p className="text-base font-semibold text-neutral-700 dark:text-neutral-300">
        Nothing here yet
      </p>
      <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-1 max-w-xs">
        {message}
      </p>
      {actionLabel && actionTo && (
        <Link
          to={actionTo as any}
          className="mt-5 inline-flex items-center gap-1.5 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
